export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fae9bf67a566ab4c7267fd992ea713a55513948ff&name=fetchTypeahead!'